import { translate } from "@atoms/atom-client/i18n";
import { LTPartType } from "../enum/PartType";

/** Part names in the UI language (read on access). */
export const PartNames: { [key in LTPartType]: string } = {
  get [LTPartType.AngleSection]() {
    return translate("app.manufacturer.partNames.angleSection", "Kantenschutz");
  },
  get [LTPartType.Corner]() {
    return translate("app.manufacturer.partNames.corner", "Ecke");
  },
  get [LTPartType.CornerBrace]() {
    return translate("app.manufacturer.partNames.cornerBrace", "L-Ecke");
  },
  get [LTPartType.Dish]() {
    return translate("app.manufacturer.partNames.dish", "Einbauschale");
  },
  get [LTPartType.Foot]() {
    return translate("app.manufacturer.partNames.foot", "Fuß");
  },
  get [LTPartType.Handle]() {
    return translate("app.manufacturer.partNames.handle", "Griff");
  },
  get [LTPartType.Hinge]() {
    return translate("app.manufacturer.partNames.hinge", "Scharnier");
  },
  get [LTPartType.PianoHinge]() {
    return translate("app.manufacturer.partNames.pianoHinge", "Klavierband");
  },
  get [LTPartType.Lock]() {
    return translate("app.manufacturer.partNames.lock", "Schloss");
  },
  get [LTPartType.Pad]() {
    return translate("app.manufacturer.partNames.pad", "Schaumstoff");
  },
  get [LTPartType.Panel]() {
    return translate("app.manufacturer.partNames.panel", "Holz");
  },
  get [LTPartType.TrayPanel]() {
    return translate("app.manufacturer.partNames.trayPanel", "Trennbretter");
  },
  get [LTPartType.Profile]() {
    return translate("app.manufacturer.partNames.profile", "Schließprofil");
  },
  get [LTPartType.RackRail]() {
    return translate("app.manufacturer.partNames.rackRail", "Rackschiene");
  },
  get [LTPartType.Roller]() {
    return translate("app.manufacturer.partNames.roller", "Rollen");
  },
  get [LTPartType.SlideRail]() {
    return translate("app.manufacturer.partNames.slideRail", "Rutschleiste");
  },
  get [LTPartType.TrolleyHandle]() {
    return translate(
      "app.manufacturer.partNames.trolleyHandle",
      "Trolley-Griff",
    );
  },
  get [LTPartType.Cutout]() {
    return translate("app.manufacturer.partNames.cutout", "Ausschnitt");
  },
  get [LTPartType.Volume]() {
    return translate("app.manufacturer.partNames.volume", "Inhalt");
  },
  get [LTPartType.Measurements]() {
    return translate("app.manufacturer.partNames.measurements", "Bemaßung");
  },
};
